import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { layerWithTable } from "../../../../resources/layerWithTable";
import { useDialogReset } from "../../../../hooks/useDialogs";
import { useDefaultScaleRange } from "../../../../hooks/style/useDefaultScaleRange";
import { SpatialReferenceData } from "./useSpatialReference";

type SpatialReferenceInfo = {
  srData: SpatialReferenceData;
  isTableSchema: boolean;
};

export const useImportApply = (
  layerName: string,
  importDone: boolean,
  srInfo: SpatialReferenceInfo,
  createLayer: VoidFunction,
): [string, VoidFunction, boolean] => {
  const { t } = useTranslation("common");
  const cancelDialog = useDialogReset();
  const defaultScaleRange = useDefaultScaleRange();

  const {
    isTableSchema,
    srData: { lonLatInOneField, srFields },
  } = srInfo;

  const isSrFieldsFilled = isTableSchema
    ? lonLatInOneField
      ? srFields.longitudeAndLatitude
      : srFields.latitude && srFields.longitude
    : true;

  const applyText = importDone ? t("actions.ready") : t("actions.ok");
  const srEmptyDisabled = applyText === t("import.createLayer", { ns: "dialogs" }) ? !isSrFieldsFilled : false;

  const onApply = useCallback(() => {
    if (importDone) {
      layerWithTable.invalidate({ name: layerName, defaultScaleRange });
      cancelDialog();
    } else {
      createLayer();
    }
  }, [importDone, layerName, defaultScaleRange, cancelDialog, createLayer]);

  return [applyText, onApply, srEmptyDisabled];
};
